import { FormattedMessage } from 'react-intl';

import { ErrorMessage } from '@atlaskit/form';

import { LoadingStatus } from 'src/constants/loading-status';
import { IssueCreationFailureReason } from 'src/redux/jira/constants';
import { Site, IssueType, Project } from 'src/redux/jira/types';

import messages from './create-jira-issue.i18n';

export const createInJiraLink = (
  site: Site | undefined,
  project: Project | undefined,
  issueType: IssueType | undefined
) => {
  if (!site || !project || !issueType) {
    return null;
  }

  return (
    <a
      target="_blank"
      href={`${site.cloudUrl}/secure/CreateIssue.jspa?pid=${project.id}&issuetype=${issueType.id}`}
    >
      <FormattedMessage {...messages.createInJiraLinkText} />
    </a>
  );
};

export const renderIssueMetaError = (
  fetchedStatus: LoadingStatus,
  failureReason: IssueCreationFailureReason,
  selectedProject: Project | undefined,
  selectedIssueType: IssueType | undefined
) => {
  if (fetchedStatus === LoadingStatus.Forbidden) {
    return (
      <ErrorMessage>
        <FormattedMessage {...messages.issueCreationForbidden} />
      </ErrorMessage>
    );
  } else if (failureReason === IssueCreationFailureReason.Unknown) {
    return (
      <ErrorMessage>
        <FormattedMessage
          {...messages.issueCreationFailedGenericMessage}
          values={{
            createInJiraLink: createInJiraLink(
              selectedProject?.site,
              selectedProject,
              selectedIssueType
            ),
          }}
        />
      </ErrorMessage>
    );
  } else if (failureReason === IssueCreationFailureReason.UnsupportedFields) {
    return (
      <ErrorMessage>
        <FormattedMessage
          {...messages.issueCreationFailedUnsupportedFieldsMessage}
          values={{
            createInJiraLink: createInJiraLink(
              selectedProject?.site,
              selectedProject,
              selectedIssueType
            ),
          }}
        />
      </ErrorMessage>
    );
  }
  return null;
};
